import { IChooseItems } from '../../../../components/mainContent/TableAllDishes'
import {
  IBuffetDishDto,
  IEdgeServers,
} from '../../../../core/api/dto/BuffetDishDto'
import React, { useState } from 'react'
import {
  useDeleteDishesToFotoboxesMutation,
  useSendDishesToFotoboxesMutation,
} from '../../../../core/api/BuffetDishApi'
import {
  AppNotification,
  NotificationType,
} from '../../../../components/notification/Notification'
import { useTranslation } from 'react-i18next'

export const uniqFilter = (data: IEdgeServers[]): IEdgeServers[] => {
  return data.reduce((accumulator, current) => {
    if (accumulator.findIndex((object) => object.id === current.id) === -1) {
      accumulator.push(current)
    }
    return accumulator as IEdgeServers[]
  }, [] as IEdgeServers[])
}

interface UseSentOnFotoboxProps {
  chooseItems: IChooseItems | null
  tableData: IBuffetDishDto[]
  setChooseItems: React.Dispatch<React.SetStateAction<IChooseItems | null>>
}

interface UseSentOnFotoboxResponse {
  isDeleteMode: boolean
  deleteStations: IEdgeServers[] | null
  sentPopup: boolean
  closeSentPopup: () => void
  openDeleteStationPopup: () => void
  openSentPopup: () => void
  onSendDishes: (value: string[]) => void
  onDeleteStationDishes: (value: string[]) => void
  isLoadingSend: boolean
}

export const useSentOnFotobox = ({
  tableData,
  chooseItems,
  setChooseItems,
}: UseSentOnFotoboxProps): UseSentOnFotoboxResponse => {
  const { t } = useTranslation()
  const [sentPopup, setSentPopup] = useState(false)
  const [isDeleteMode, setIsDeleteMode] = useState(false)
  const [deleteStations, setDeleteStations] = useState<IEdgeServers[] | null>(
    null,
  )
  const [sendDishesToFotoboxes, { isLoading: isLoadingSend }] =
    useSendDishesToFotoboxesMutation()
  const [deleteDishesToFotoboxes] = useDeleteDishesToFotoboxesMutation()

  const chooseDishes = tableData
    .filter((item) => chooseItems && chooseItems[item.id] && !item.archived)
    .map((item) => item.guid)

  const closeSentPopup = () => {
    setSentPopup(false)
    setIsDeleteMode(false)
    setDeleteStations(null)
  }
  const openDeleteStationPopup = () => {
    setSentPopup(true)
    setIsDeleteMode(true)
    const deleteStation = uniqFilter(
      tableData
        .filter((item) => chooseItems && chooseItems[item.id] && !item.archived)
        .map((item) => item.edgeServers)
        .flat(1),
    )
    setDeleteStations(deleteStation)
  }
  const openSentPopup = () => setSentPopup(true)

  const onSendDishes = (value: string[]) => {
    if (value.length && chooseDishes.length) {
      sendDishesToFotoboxes({
        dishesGuids: chooseDishes,
        edgeServersGuids: value,
      })
        .unwrap()
        .then(() => {
          AppNotification({
            type: NotificationType.success,
            msg: t('Блюда успешно отправлены на выбранные станции'),
          })
          setChooseItems(null)
          setSentPopup(false)
        })
    }
  }
  const onDeleteStationDishes = (value: string[]) => {
    if (value.length && chooseDishes.length) {
      deleteDishesToFotoboxes({
        dishesGuids: chooseDishes,
        edgeServersGuids: value,
      })
        .unwrap()
        .then(() => {
          AppNotification({
            type: NotificationType.success,
            msg: t('Блюда успешно удалены с выбранных станций'),
          })
          setChooseItems(null)
          setSentPopup(false)
          setIsDeleteMode(false)
          setDeleteStations(null)
        })
    }
  }

  return {
    isDeleteMode,
    deleteStations,
    sentPopup,
    closeSentPopup,
    openSentPopup,
    openDeleteStationPopup,
    onDeleteStationDishes,
    onSendDishes,
    isLoadingSend,
  }
}
